import {getCompressedCartItems} from "./backendFunctions";

export const isLocalStorageQuotaExceeded = (error) => {
  return !!(
    error
    && (
      error.name === "QuotaExceededError"
      || error.name === "NS_ERROR_DOM_QUOTA_REACHED"
      || error.code === 22
      || error.code === 1014
    )
  );
};

export const setLocalStorageState = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    if (!isLocalStorageQuotaExceeded(error)) {
      throw error;
    }

    window.localStorage.removeItem(key);
    window.localStorage.setItem(key, value);
  }
};

export const getCameFromPageForLocalStorage = (cameFromPage) => {
  if (!cameFromPage || typeof cameFromPage === "string") {
    return cameFromPage;
  }

  if (!cameFromPage.dbFeature) {
    return "";
  }

  return {
    isCompressedCameFromPage: true,
    partId: cameFromPage.partId,
    dbFeatureId: cameFromPage.dbFeature.id,
    sku: cameFromPage.dbFeature.sku,
    sharedFeatureName: cameFromPage.dbFeature.sharedFeatureName,
  };
};

export const restoreCameFromPageFromLocalStorage = (cameFromPage, layout) => {
  if (!cameFromPage || !cameFromPage.isCompressedCameFromPage) {
    return cameFromPage;
  }

  return layout.getFeatureById(cameFromPage.dbFeatureId, true) || {
    partId: cameFromPage.partId,
    dbFeature: {
      id: cameFromPage.dbFeatureId,
      sku: cameFromPage.sku,
      sharedFeatureName: cameFromPage.sharedFeatureName,
    },
  };
};

export const getCartStateForLocalStorage = (cartState) => {
  return Object.assign({}, cartState, {
    applyPopupOpened: false,
    activeApplyPopupItems: [],
    cameFromPage: getCameFromPageForLocalStorage(cartState.cameFromPage),
    recentlyViewedItems: [],
    checkoutPopupVisible: false,
    orderCompletePopupVisible: false,
    depositVisible: false,
    depositCallback: null,
    cartItems: getCompressedCartItems(cartState.cartItems),
    displayLogicCartItems: getCompressedCartItems(cartState.displayLogicCartItems),
    cartItemEditFeature: null,
  });
};
